/*
 * Created by jmeo at 2021-05-13
 * FileName: index.ts
 */

/**
 * 接口参数， 数据录入来源
 */

// 用户类型
export const USER_SALE = 'dealer' // 销售
export const USER_MANAGE = 'manager' //客户管理

export const formatString = 'YYYY-MM-DD HH:mm'


export const RejectReasons: {[key: string]: string} = {
  '00':'手机号错误',
  '01': '身份证号码错误',
}